import { render, staticRenderFns } from "./uploading.vue?vue&type=template&id=32675257&scoped=true&"
import script from "./uploading.vue?vue&type=script&lang=ts&"
export * from "./uploading.vue?vue&type=script&lang=ts&"
import style0 from "./uploading.vue?vue&type=style&index=0&id=32675257&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32675257",
  null
  
)

export default component.exports